import _ from 'underscore';

function parseResponse({ result, sourceItems = [] }) {
  if (_.isEmpty(result)) {
    return {
      ...result,
      errors: [{
        Error: 'UnexpectedError',
        Type: 'Unexpected Error',
      }],
    };
  }

  let { entity } = result;
  if (!entity) {
    entity = result;
  }

  if (entity.Budget) {
    // standard budget error
    const sourceItem = _.findWhere(sourceItems, { CampaignId: entity.Id });
    return {
      Amount: entity.Budget.Amount,
      UpdateType: entity.Budget.Type,
      CampaignId: entity.Id,
      errors: result.errors,
      sourceItem,
    };
  }
  // shared budget error
  const sourceItem = _.findWhere(sourceItems, { BudgetId: entity.Id });
  return {
    Amount: entity.Amount,
    UpdateType: 'DailyShared',
    BudgetId: entity.Id,
    errors: result.errors,
    sourceItem,
  };
}

export function logSingleResponse({
  activity, api, result, sourceItems,
}) {
  const logMessage = parseResponse({ result, sourceItems });
  if (!_.isEmpty(logMessage.errors)) {
    activity.error(JSON.stringify(logMessage), api);
  } else {
    activity.trace(JSON.stringify(logMessage), api);
  }
}

export function logUpdateBudget({
  activity, api, response, sourceItems,
}) {
  const getErrorLog = (item) => {
    if (_.isArray(item)) {
      item.forEach((i) => {
        getErrorLog(i);
      });
    } else {
      logSingleResponse({
        activity, result: item, api, sourceItems,
      });
    }
  };

  getErrorLog(response);
}
